import React from 'react';
import './Navbar.css';
import { Fade } from 'react-reveal';
import { NavLink, Link } from 'react-router-dom';

const onMouseEnter = (e, color) => {
  const hover = e.target;
  hover.style.backgroundColor = color;
};

const onMouseOut = (e) => {
  const hover = e.target;
  hover.style.backgroundColor = 'transparent';
};

const Navbar = () => {
  return (
    <Fade top duration={800} distance='20px'>
      <div>
        <header className='header'>
          <NavLink to='/' tag={Link} className='logo'>
            <span className='logo-name'> &lt;</span>
            <span className='logo-name'>Ollivier Julles Morales</span>
            <span className='logo-name'>/&gt;</span>
          </NavLink>
          <input className='menu-btn' type='checkbox' id='menu-btn' />
          <label className='menu-icon' htmlFor='menu-btn'>
            <span className='navicon'></span>
          </label>
          <ul className='menu'>
            <li>
              <NavLink
                to='/home'
                tag={Link}
                activeStyle={{ fontWeight: 'bold' }}
                style={{ color: '#000000' }}
                onMouseEnter={(e) => onMouseEnter(e, '#ABB2B9')}
                onMouseOut={(e) => onMouseOut(e)}
              >
                Home
              </NavLink>
            </li>
            <li>
              <NavLink
                to='/education'
                tag={Link}
                activeStyle={{ fontWeight: 'bold' }}
                style={{ color: '#000000' }}
                onMouseEnter={(e) => onMouseEnter(e, '#ABB2B9')}
                onMouseOut={(e) => onMouseOut(e)}
              >
                Education
              </NavLink>
            </li>
            <li>
              <NavLink
                to='/experience'
                tag={Link}
                activeStyle={{ fontWeight: 'bold' }}
                style={{ color: '#000000' }}
                onMouseEnter={(e) => onMouseEnter(e, '#ABB2B9')}
                onMouseOut={(e) => onMouseOut(e)}
              >
                Experience
              </NavLink>
            </li>
            <li>
              <NavLink
                to='/projects'
                tag={Link}
                activeStyle={{ fontWeight: 'bold' }}
                style={{ color: '#000000' }}
                onMouseEnter={(e) => onMouseEnter(e, '#ABB2B9')}
                onMouseOut={(e) => onMouseOut(e)}
              >
                Projects
              </NavLink>
            </li>
            <li>
              <NavLink
                to='/contact'
                tag={Link}
                activeStyle={{ fontWeight: 'bold' }}
                style={{ color: '#000000' }}
                onMouseEnter={(e) => onMouseEnter(e, '#ABB2B9')}
                onMouseOut={(e) => onMouseOut(e)}
              >
                Contact Me
              </NavLink>
            </li>
          </ul>
        </header>
      </div>
    </Fade>
  );
};

export default Navbar;
